import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon_chevron-right",
  "use": "icon_chevron-right-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" id=\"icon_chevron-right\"><path d=\"M18.747 12.777l-8.901 8.901a1.1 1.1 0 01-1.555 0L7.253 20.64a1.1 1.1 0 01-.002-1.553L14.305 12 7.252 4.913a1.1 1.1 0 01.002-1.553l1.038-1.038a1.1 1.1 0 011.555 0l8.9 8.9c.43.43.43 1.126 0 1.555z\" fill=\"currentColor\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol